<template>
  <div class="requestappt">
    <b-container fluid>
      <b-row class="mycontainer-main">
        <b-col cols="12" md="4" class="pl-5 leftcontent">
          <h6 class="my-0" style="color: grey">{{ $t("common.form") }}</h6>
          <h2>{{ $t("requestappt.jumbo_title") }}</h2>
          <br />
          <h1 style="font-weight: 900; font-size: 1.9em">
            {{ $t("requestappt.jumbo_desc") }}
          </h1>
          <b-button squared variant="outline-dark" class="mt-3" @click="goBack">
            {{ $t("common.goback") }}
          </b-button>
        </b-col>

        <b-col
          cols="12"
          md="6"
          class="align-self-center py-3"
          id="apptform"
          v-if="!submitComplete"
        >
          <b-card-group deck>
            <b-card
              class="shadow"
              img-top
              :img-src="require('../assets/images/bookonline.jpg')"
            >
              <b-card-title>{{ $t("requestappt.bookonline") }}</b-card-title>
              <b-card-text>{{ $t("requestappt.bookonline_desc") }}</b-card-text>
              <b-button
                squared
                style="background-color: black"
                class="mt-2 shadow"
                @click="GoToBookingSite"
                >{{ $t("requestappt.booknow") }}</b-button
              >
            </b-card>
            <b-card
              v-if="!inquire"
              class="shadow"
              img-top
              :img-src="require('../assets/images/inquire.jpg')"
            >
              <b-card-title>{{ $t("requestappt.inquire") }}</b-card-title>
              <b-card-text>{{ $t("requestappt.inquire_desc") }}</b-card-text>
              <b-button
                squared
                style="background-color: black"
                class="mt-2 shadow"
                @click="ChoiceInquire()"
                >{{ $t("requestappt.form") }}</b-button
              >
            </b-card>
          </b-card-group>

          <b-card class="shadow mt-2" v-if="inquire">
            <b-form @submit="onSubmit" @reset="onReset" v-if="show">
              <h4>{{ $t("requestappt.q1") }}</h4>

              <b-form-group id="input-group-5">
                <b-form-checkbox-group
                  v-model="form.service"
                  id="checkboxes-5"
                  size="lg"
                >
                  <b-form-checkbox
                    v-for="(s, index) in display.service"
                    :key="index"
                    :value="s"
                  >
                    {{ s }}
                  </b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>

              <b-form-group
                id="textarea"
                :label="display.notes + ':'"
                label-for="textarea"
              >
                <b-form-textarea
                  id="textarea"
                  v-model="form.notes"
                  :placeholder="display.enterNotes"
                  rows="3"
                  max-rows="6"
                ></b-form-textarea>
              </b-form-group>

              <h4>{{ $t("requestappt.q2") }}</h4>

              <b-form-group id="input-group-4">
                <label for="datepicker">{{ $t("requestappt.q3") }}</label>
                <b-form-datepicker
                  id="datepicker"
                  v-model="form.date"
                  class="mb-2"
                  :placeholder="display.enterDate"
                ></b-form-datepicker>

                <b-form-radio-group v-model="form.time" id="time" size="lg">
                  <b-form-radio
                    v-for="(s, index) in display.times"
                    :key="index"
                    :value="s"
                  >
                    {{ s }}
                  </b-form-radio>
                </b-form-radio-group>
              </b-form-group>

              <h4>{{ $t("requestappt.q4") }}:</h4>

              <b-form-group
                id="input-group-2"
                :label="display.name + ':'"
                label-for="input-2"
              >
                <b-form-input
                  id="input-2"
                  v-model="form.name"
                  required
                  :placeholder="display.enterName"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                :label="display.email + ':'"
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  v-model="form.email"
                  type="email"
                  required
                  :placeholder="display.enterEmail"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                id="input-group-3"
                :label="display.phone + ':'"
                label-for="input-3"
              >
                <b-form-input
                  id="input-3"
                  v-model="form.phone"
                  required
                  :placeholder="display.enterPhone"
                ></b-form-input>
              </b-form-group>

              <b-button type="submit" squared variant="dark">{{
                $t("common.submit")
              }}</b-button>
              <b-button type="reset" squared variant="outline-dark">{{
                $t("common.reset")
              }}</b-button>
            </b-form>

            <div v-else>
              <b-card-title
                ><b-spinner v-if="submitting"></b-spinner
              ></b-card-title>
            </div>
          </b-card>
        </b-col>

        <b-col cols="12" md="6" class="align-self-center py-3">
          <b-card-title v-if="submitComplete">{{
            $t("requestappt.submitted")
          }}</b-card-title>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
const enData = {
  name: "Name",
  email: "Email",
  phone: "Phone Number",
  service: [
    "Facial",
    "Peelings",
    "Microdermabrasion",
    "Hair Removal",
    "Phototherapy",
    "Online Consultation",
    "In-Clinic Consultation",
  ],
  notes: "Notes For Us",
  times: ["morning", "afternoon", "evening"],
  enterNotes: "Type here...",
  enterDate: "No Date Selected",
  enterName: "Enter Name",
  enterEmail: "Enter Email",
  enterPhone: "Enter Phone Number",
};

const frData = {
  name: "Nom",
  email: "Courriel",
  phone: "Numéro de téléphone",
  service: [
    "Facial",
    "Peelings",
    "Microdermabrasion",
    "Épilation traditionnelle ou définitive",
    "Photofacial",
    "Consultation en ligne",
    "Consultation en clinique",
  ],
  notes: "Notes pour notre équipe",
  times: ["Matin", "Après-midi", "Soir"],
  enterNotes: "Écrivez ici...",
  enterDate: "Aucune date sélectionnée",
  enterName: "Entrez le nom",
  enterEmail: "Entrez votre e-mail",
  enterPhone: "Entrez le téléphone",
};

export default {
  name: "requestappt",
  data() {
    return {
      msg: "Welcome to BI",
      show: true,
      display: "",
      form: {
        name: "",
        email: "",
        phone: "",
        service: [],
        notes: "",
        date: "",
        time: "",
        language_code: this.$i18n.locale,
      },
      submitComplete: false,
      submitting: false,
      inquire: false,
    };
  },

  methods: {
    ChoiceInquire() {
      this.inquire = !this.inquire;
    },
    GoToBookingSite() {
      window.location.href = "https://reservations.beauteintegrale.ca";
    },
    getImg(p) {
      var images = require.context("../assets/images/", false, /\.jpg$/);
      return images("./" + p + ".jpg");
    },
    goBack() {
      this.$router.go(-1);
    },
    onSubmit(evt) {
      evt.preventDefault();
      // let data = (JSON.stringify(this.form))
      this.form.date = new Date(this.form.date);
      let data = Object.assign({}, this.form);
      this.submitting = true;
      this.show = false;
      axios
        .post(
          "https://api.beauteintegrale.ca/submissions/appointments/requests",
          data
        )
        .then((resp) => {
          this.submitting = false;
          this.submitComplete = true;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    onReset(evt) {
      evt.preventDefault();
      // Reset our form values
      this.form.email = "";
      this.form.name = "";
      this.form.phone = "";
      this.form.service = [];
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    getData() {
      if (this.$i18n.locale == "fr") {
        this.display = frData;
      } else this.display = enData;
    },
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
  },
  mounted() {
    this.getData();
  },
  watch: {
    locale: function (newLocale, oldLocale) {
      this.getData();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mycontainer-main {
  min-height: calc(90vh);
}
/* .mycontainer-main2 {
    min-height: 10vh ;
} */
.m-borders {
  border: 3px solid white;
}

#clinicservices .card-columns {
  column-count: 2;
}
@media (max-width: 576px) {
  #clinicservices .card-columns {
    column-count: 1;
  }
}
.leftcontent {
  padding-top: 30vh;
  padding-bottom: 10vh;
}
.card-img-top {
  width: 100%;
  height: 20rem;
  object-fit: cover;
}
h4 {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/pages/RequestAppt.vue